import { showNotification } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";
import { captureException } from "@/services/log";
import { createLicenciadaWithEmpresa } from "../functions";

export const useCreateLicenciada = () => {
  return useMutation({
    mutationFn: createLicenciadaWithEmpresa,
    onSuccess: () => {
      showNotification({
        title: "Licenciada criada com sucesso!",
        message: `Licenciada foi criada e configurada com sucesso.`,
        color: "green",
        autoClose: 5000
      });
    },
    onError: (error: unknown) => {
      console.error("Erro ao criar licenciada:", error);
      if (error instanceof Error) {
        captureException(error, true);
      } else if (typeof error === "string") {
        captureException(new Error(error), true);
      } else {
        try {
          captureException(new Error(JSON.stringify(error)), true);
        } catch {
          captureException(new Error("Erro desconhecido"), true);
        }
      }

      let errorMessage = "Erro interno do servidor";

      if (error instanceof Error) {
        errorMessage = error.message;
      } else if (typeof error === "string") {
        errorMessage = error;
      } else {
        try {
          const maybe = JSON.stringify(error);
          if (maybe) errorMessage = maybe;
        } catch {
          // do nothing
        }
      }

      showNotification({
        title: "Erro ao criar licenciada",
        message: errorMessage,
        color: "red",
        autoClose: 8000
      });
    }
  });
};
